// function moved from shared folder because it caused build erros
import { Router, SingletonRouter } from "next/router";
import type { NextRouter } from "next/router";
import { RefObject, useEffect } from "react";

import { scrollTo } from "shared/lib/functions";

export const formatPassengerRecapitulation = (
  passengerPrices: Array<{
    Code: string;
    FullPricePerPassenger: number;
    OperatorFeePerPassenger: number;
  }>
): Array<{
  code: string;
  count: number;
  price: number;
  operatorFee: number;
}> => {
  const filteredPassengers = [];
  passengerPrices.forEach((passenger) => {
    if (filteredPassengers.length === 0) {
      filteredPassengers.push({
        code: passenger.Code,
        count: 1,
        price: passenger.FullPricePerPassenger,
        operatorFee: passenger.OperatorFeePerPassenger,
      });
    } else {
      const found = filteredPassengers.find((el) => el.code === passenger.Code);
      if (found) {
        found.count++;
      } else {
        filteredPassengers.push({
          code: passenger.Code,
          count: 1,
          price: passenger.FullPricePerPassenger,
          operatorFee: passenger.OperatorFeePerPassenger,
        });
      }
    }
  });
  return filteredPassengers;
};

export const useOutsideClick = (
  ref: RefObject<HTMLElement>,
  callback: () => void
): void => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};

export function checkIsHotelSearchForm({ query }: SingletonRouter): boolean {
  return query?.typeSearch === "hotels" || query?.typeSearch === "hotel";
}

export function checkIsFlightSearchForm({ query }: SingletonRouter): boolean {
  return query?.typeSearch === "flights";
}

export function scrollToErrorDynamicForm(): void {
  const errorFields = document.querySelector(".booking-form-element-error");

  if (errorFields !== null) {
    scrollTo(".booking-form-element-error");
    return;
  }

  const addNewGuestLinks = document.querySelector(
    ".form-text-input-search-guest-new-label"
  ) as HTMLSpanElement;

  if (addNewGuestLinks) {
    addNewGuestLinks.click();
    setTimeout(() => {
      scrollTo(".booking-form-element-error");
    }, 500);
  }
}

export const routeChangeFallback = (
  cb: () => void,
  router: NextRouter
): void => {
  let routeChangeStarted = false;

  const routeChangeStartHandle = () => {
    routeChangeStarted = true;
  };

  Router.events.on("routeChangeStart", routeChangeStartHandle);

  setTimeout(() => {
    if (routeChangeStarted) {
      Router.events.off("routeChangeStart", routeChangeStartHandle);
      return true;
    }
    if (typeof window !== "undefined" && window.history.length === 2) {
      router.push("/");
    } else {
      cb();
    }
    Router.events.off("routeChangeStart", routeChangeStartHandle);
  }, 1000);
};

export function redirect(router: NextRouter, path = "/"): void {
  const params = router.query.lang ? `?lang=${router.query.lang}` : "";
  window.location.href = path + params;
}

export const errorCodesToRedirect = ["3054", "3092", "3001"];
